import script from "./EcommerceContactInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./EcommerceContactInfo.vue?vue&type=script&setup=true&lang=js"

import "./EcommerceContactInfo.vue?vue&type=style&index=0&id=4b0066f8&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b0066f8"]])

export default __exports__